export default {
    TOGGLE: "TOGGLE",
    DEFAULT: "DEFAULT",
    BOT_MESSAGE: "BOT_MESSAGE",
    USER_MESSAGE: "USER_MESSAGE"
}
